<template>
  <div class="compass">
    <img
      src="@/assets/icon-compass.svg"
      height="auto"
      width="64"
      alt
      :style="`transform: rotate(${rotate}deg)`"
    />
  </div>
</template>

<script>
export default {
  name: "Compass",
  props: {
    rotate: {
      type: [Number, String],
      default: 0,
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/styles/Compass.scss';
</style>
